<template>
    <div class="page-list">
        <div class="page-list__header">
            <WorkoutCard :workout="workout" layout="header">
                <p class="card-description">{{ $root.t('Temos algumas opções para este treino, escolha a sua:') }}</p>
                <a @click="$root.returnToPreviousPage()" href="javascript:void(0);" class="btn btn-outline" >{{ $root.t('Voltar para os treinos') }}</a>
            </WorkoutCard>
        </div>

        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-md-6">

                    <div v-if="cardSubWorkouts">
                        <section class="card-list" v-for="sub in cardSubWorkouts" :key="sub.ID">
                            <h5 class="card-title"><span v-html="sub.title"></span></h5>
                            <p class="card-description" v-html="sub.description"></p>
                            <div @click="gaTrainButton(sub)">
                                <router-link
                                    :to="getPermalink(sub)"
                                    class="btn btn-lg btn-outline"
                                >
                                    {{ $root.t('Ver Treinos') }}
                                </router-link>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WorkoutCard from '@/components/WorkoutCard'

export default {
    components : { WorkoutCard },
    data () {
        return {
            cardSubWorkouts : [],
            workoutId : this.$route.params.id,
            workout : [],
            workoutTitle : '',
        }
    },
    computed : {
        ...mapGetters([ 'workouts', 'subWorkouts','theme', 'activeWorkout' ])
    },
    watch: {
        workouts () {
            this.setActiveWorkout(this.workoutId)
        },
        subWorkouts() {
            this.getSubworkouts()
        },
    },
    created () {
        console.log(this.workoutId)
        if ( this.subWorkouts && this.subWorkouts.length ) {
            this.getSubworkouts()
        }

    },
    methods : {
        ...mapActions({ setActiveWorkout : 'setActiveWorkout' }),
        getSubworkouts () {
            this.workout = this.$store.state.workouts.find((item) => item.slug == this.workoutId)
            this.cardSubWorkouts = this.subWorkouts.filter((item) => item.parent == this.workout.ID)
            this.workoutTitle = this.workout ? this.workout.title : ''
        },
        gaTrainButton({title}) {
            this.$gtm.trackEvent({
                event: 'gaEvent',
                eventCategory: `treine-em-casa-${this.theme}`,
                eventAction: title,
                eventLabel: ''
            })
        },
        getPermalink (subWorkout) {
            if(!this.activeWorkout) this.setActiveWorkout(this.workoutId)

            if ( (!subWorkout.videos || !subWorkout.videos.length) && (subWorkout['treinos-custom'] && subWorkout['treinos-custom'].length) ) {
                return `/treino/${this.activeWorkout.slug}/view/${subWorkout.slug}`
            }

            return subWorkout.videos && subWorkout.videos.length ? `/treino/${subWorkout.slug}` :  `/treino/${subWorkout.slug}/list`
        }
    }
}
</script>


<style lang="scss" scoped>
    @import "@/assets/scss/settings/_variables.scss";
    @import "@/assets/scss/settings/_mixins.scss";

    .page-list {
        .container {
            padding: 40px 20px;
        }

        .card-list {
            border: 1px solid #404040;
            border-radius: 8px;
            padding: 30px;
            width: 100%;
            margin-bottom: 20px;

            .card-title {
                span {
                    font-size: 22px;
                }
            }
        }
    }

    @media only screen and (min-width: 600px) {
        .page-list {
            .container {
                padding: 80px 20px;
            }

            &__header {
                height: 80vh;
                max-height: 700px;

                .card-description {
                    color: #ccc;
                    margin-bottom: 0;
                }

                .card-title {
                    font-size: 22px;

                    span {
                        font-size: 42px;
                    }
                }

                a {
                    margin-top: 20px
                }
            }
        }
    }
</style>
